import { useQuery } from '@apollo/client';
import { HAS_STUDIOS } from '../graphql/queries/queries';
import { isHostVisibleStudio } from '../util/studioStatus';

export const useHasStudios = (userId) => {
  const { data, loading, error } = useQuery(HAS_STUDIOS, {
    variables: { 
      userID: userId
    },
    skip: !userId,
    fetchPolicy: 'cache-and-network',
  });

  const visibleStudios = (data?.studiosByUserID?.items || []).filter(isHostVisibleStudio);
  const hasStudios = visibleStudios.length > 0;

  return {
    hasStudios,
    loading,
    error,
  };
};